<template>
    <header class="mh-header">
        <router-link class="mh-brand" to="/Home" :aria-label="brandName"><img v-if="logoUrl && !logoFailed" :src="logoUrl" :alt="brandName" @error="logoFailed = true" /><span v-else>{{ brandName }}</span></router-link>
        <div v-if="!isLogin" class="mh-header-actions">
            <button type="button" class="mh-login" @click="login(2)">{{ pcCopy.login }}</button>
            <button type="button" class="mh-register" @click="login(1)">{{ pcCopy.register }}</button>
        </div>
        <div v-else class="mh-header-actions mh-signed-in">
            <button type="button" class="mh-balance" :aria-label="mobileHomeCopy.account" @click="onNavToByIsLogin({ url: '/PersonBox' })">{{ CurrencyType }}{{ allBalance }}</button>
            <button type="button" class="mh-register" @click="onNavToByIsLogin({ url: '/wallet', type: 'get', params: { type: 'deposit' } })">{{ mobileHomeCopy.deposit }}</button>
        </div>
    </header>
</template>

<script>
import { domainKey } from '@/common/http'
import desktopCopy from '@/components/desktop/copy'
import mobileCopy from './copy'
export default {
    mixins: [desktopCopy, mobileCopy],
    data() { return { logoFailed: false } },
    computed: {
        isLogin() { return !!this.$store.getters.token },
        brandName() { return this.$store.getters.sysConfig?.projectName || domainKey },
        logoUrl() { return this.$store.getters.sysConfig?.homeLogoUrl || this.$store.getters.sysConfig?.homeImageUrl }
    },
    watch: { logoUrl() { this.logoFailed = false } },
    methods: { login(type) { this.$store.dispatch('user/changeLoginType', type); this.$store.dispatch('user/setIsShowLoginPopup', true) } }
}
</script>

<style scoped lang="scss">
.mh-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 60px; padding: 10px 12px; background: #121418; color: #f7f6f5; font-family: Inter, "Segoe UI", Arial, sans-serif; }
.mh-brand { display: flex; align-items: center; gap: 3px; color: #f7f6f5; text-decoration: none; flex-shrink: 0; font-size: 26px; line-height: 1; letter-spacing: -.9px; font-weight: 750; }
.mh-brand img { width: 144px; height: 34px; object-fit: contain; object-position: left center; }
.mh-header-actions { display: flex; align-items: center; gap: 8px; min-width: 0; }
.mh-header-actions button { min-height: 40px; padding: 8px 10px; border: 1px solid #676870; border-radius: 9px; background: #181b20; color: #f7f6f5; font: 600 13px/1.25 Inter, "Segoe UI", Arial, sans-serif; cursor: pointer; }
.mh-header-actions .mh-register { background: #ff6055; border-color: #ff6055; }
.mh-header-actions .mh-balance { border: 0; max-width: 110px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px; }
button:focus-visible, a:focus-visible { outline: 2px solid #ff6055; outline-offset: 3px; }
@media (max-width: 375px) { .mh-header { gap: 6px; padding-inline: 10px; } .mh-brand { font-size: 21px; } .mh-brand img { width: 120px; height: 29px; } .mh-header-actions { gap: 5px; } .mh-header-actions button { font-size: 11px; padding-inline: 7px; } }
</style>
